module.exports = __webpack_public_path__ + "img/vector-sign-in.dc918203.png";